import React from "react";

import { REACT_TOOLTIP_ClASS_NAME } from "./constant";

import { createPortal } from "react-dom";

export const initCustomTooltip = (setTooltipNode, props, spec) => {
    var _a, _b, _c;
    const nextSpec = Object.assign({}, null != spec ? spec : {});
    let render;
    if ((null == spec ? void 0 : spec.tooltipRender) ? (render = spec.tooltipRender, 
    delete nextSpec.tooltipRender) : props.tooltipRender && (render = props.tooltipRender), 
    render) {
        let reserve;
        if ((null == spec ? void 0 : spec.reserveDefaultTooltip) ? (reserve = spec.reserveDefaultTooltip, 
        delete nextSpec.reserveDefaultTooltip) : reserve = props.reserveDefaultTooltip, 
        !reserve) {
            const panelStyle = Object.assign({}, null !== (_b = null === (_a = nextSpec.style) || void 0 === _a ? void 0 : _a.panel) && void 0 !== _b ? _b : {});
            panelStyle.padding = 0, panelStyle.border = Object.assign(Object.assign({}, panelStyle.border), {
                radius: 0
            }), panelStyle.backgroundColor = "unset", nextSpec.style = Object.assign(Object.assign({}, null !== (_c = nextSpec.style) && void 0 !== _c ? _c : {}), {
                panel: panelStyle
            });
        }
        return Object.assign(Object.assign({}, nextSpec), {
            updateElement: (el, actualTooltip, params) => {
                const {changePositionOnly: changePositionOnly} = params;
                if (!changePositionOnly) {
                    if (!reserve) {
                        el.style.width = "auto", el.style.height = "auto", el.style.minHeight = "auto";
                        for (let i = 0; i < el.children.length; i++) {
                            const childNode = el.children[i];
                            childNode.className !== REACT_TOOLTIP_ClASS_NAME && "none" !== childNode.style.display && (childNode.style.display = "none");
                        }
                    }
                    setTooltipNode(createPortal(React.createElement("div", {
                        className: REACT_TOOLTIP_ClASS_NAME
                    }, render(el, actualTooltip, params)), el));
                }
            }
        });
    }
    return spec;
};
//# sourceMappingURL=util.js.map
